module.exports = __webpack_public_path__ + "static/media/apple-icon-152x152.240a3f5c.png";